import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const recipes = 
{
    namespaced: true,
    state: {
        recipes: [],
        recipe: {},
        recipeUpdateStatus: {},
    },
    mutations: {
        SET_RECIPES(state, data)
        {
            state.recipes = data
        },
        SET_RECIPE(state, data)
        {
            state.recipe = data
        },
        SET_RECIPE_UPDATESTATUS(state, data)
        {
            state.recipeUpdateStatus = data
        }
    },
    actions: {
        getAll ({ commit, dispatch }) {
          return axios 
          .get(baseUrl+'Recipes', { withCredentials: true })
          .then(res => {
            //   console.log(res.data);
              commit('SET_RECIPES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteRecipe ({ commit, dispatch }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateRecipe({ commit }, {id, data}){
            return axios
            .post(baseUrl+'Recipes/updateRecipe/'+id, data, { withCredentials: true })
            .then(res => {
                console.log(res.data);
                commit('SET_RECIPE_UPDATESTATUS', {success: res.data == 1 ? true:false})
                console.log({success: res.data == 1 ? true:false});
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getRecipe ({ commit, dispatch },id) {
            return axios
            .get(baseUrl+'Recipes/' + id, { withCredentials: true })
            .then(res => {
                commit('SET_RECIPE', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewRecipe ({ commit, dispatch }, data) {
            return axios
            .post(baseUrl+'Recipes/addRecipe', data, { withCredentials: true })
            .then(res => {
                commit('SET_RECIPE', [{id: res.data}])
            })
            .catch(error => console.log(error))
        },

       
      },
      getters: {}
}

export default recipes